import { BaseErrorBoundary, BaseErrorBoundaryProps, BaseErrorBoundaryState } from './BaseErrorBoundary';

export class ErrorBoundary extends BaseErrorBoundary<BaseErrorBoundaryProps, BaseErrorBoundaryState> {
  constructor(props: BaseErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      errorId: this.generateErrorId(),
      timestamp: new Date(),
      retryCount: 0,
    };
  }

  static getDerivedStateFromError(error: Error): Partial<BaseErrorBoundaryState> {
    return {
      hasError: true,
      error,
      errorId: `error_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date(),
    };
  }
}
